import React, { useEffect, useState, useContext, Component } from "react"
import { Link } from "react-router-dom";
import moment from "moment";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import { apiEndpoint } from "helpers/url_helper";



import {
    Col,
    Row,
    Card,
    CardBody,
    CardTitle,
    Modal,
    ModalBody,
    ModalHeader,
    Button,
    ModalFooter,
    Dropdown,
  } from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { isEmpty, isUndefined } from "lodash";
import {AllUsersListContext} from "components/Common/PageDataContext";

  //Style
  const btnstylesObj = {
    "marginTop": '3rem',
  };

  const Option  = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const UserRegistratinoModalComponent =  (props) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);

    // User Details
    const [FirstName, setFirstName] = useState(false);
    const [LastName, setLastName] = useState(false);
    const [EmailID, setEmailID] = useState(false);
    const [MobileNumber, setMobileNumber] = useState(false);
    
    // Login Details
    const [UserName, setUserName] = useState(false);
    const [Password, setPassword] = useState(false);
    const [ConfirmPassword, setConfirmPassword] = useState(false);

    // Access Details - Email, SMS & End of the day Mail
    const [SendMail, setSendMail] = useState(true);
    const [SendSMS, setSendSMS] = useState(true);
    const [SendEodMail, setSendEodMail] = useState(true);

    // Access Details - User Role Dropdown
    const [Userroleitems, setUserroleItems] = useState([]);
    const [SelectedUserroleitem, setSelectedUserroleItem] = useState([]);
    const [selectedUserroleVal, setUserroleSelected] = useState();

    // Access Details - Campus Dropdown
    const [Campusitems, setCampusItems] = useState([]);
    const [SelectedCampusitem, setSelectedCampusItem] = useState([]);
    const [selectedCampusVal, setCampusSelected] = useState({});

    const [alertmsg, setAlert] = useState([]);

    const { usersData, setUsersData } = useContext(AllUsersListContext);

    
    // Note: the empty deps array [] means
    // this useEffect will run once
    // similar to componentDidMount()
    // get Campus List
    useEffect(() => {
 
      // UserValidated
      fetch(apiEndpoint+"/GetLogCampusList",
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            "strToken": sessionStorage.getItem("Clear_AuthUser")
            
          })
        })  
          .then(res => res.json())
          .then(
            (result) => {
              if (result != undefined) {
                //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                if (result.CampusList != undefined) {
                  setCampusItems(JSON.parse(result.CampusList));
                  // var campuslst = JSON.parse(result.CampusList);
                  // setSelectedCampusItem(campuslst[0]);
                  // setCampusSelected(campuslst[0].value);
                }
              }
              },
              // Note: it's important to handle errors here
              // instead of a catch() block so that we don't swallow
              // exceptions from actual bugs in components.
              (error) => {
                  //console.log(error);
                  // /setError(error);
              }
          )

          // UserValidated
          fetch(apiEndpoint+"/GetAllUserRoles",
            {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              "Token": sessionStorage.getItem("Clear_AuthUser")
            })
            })
          .then(res => res.json())
          .then(
            (result) => {
              if (result != undefined) {
                if(result.status){
                  //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                  setUserroleItems(JSON.parse(result.UserRoleList));
                  var UserRoleList = JSON.parse(result.UserRoleList);
                  setSelectedUserroleItem(UserRoleList[0]);
                  setUserroleSelected(UserRoleList[0].value);
                }
                else{
                  setAlert (
                    <ReactBSAlert
                      warning
                      title="Warning"
                      onConfirm={() => SessionExpired()}
                      onCancel={() => setAlert(null)}
                      confirmBtnBsStyle="info"
                    >
                      {result.Message}
                    </ReactBSAlert>
                  )
                }
                
              }
              },
              // Note: it's important to handle errors here
              // instead of a catch() block so that we don't swallow
              // exceptions from actual bugs in components.
              (error) => {
                  //console.log(error);
                  // /setError(error);
              }
          )
    }, [])

    // Access Details - Location Dropdown
    const [Locitems, setLocItems] = useState([]);
    const [SelectedLocitem, setSelectedLocItem] = useState([]);
    const [selectedLocVal, setLocSelected] = useState({});
    
    const toggle = () => {
        setAlert(null);
        setModalIsOpen(!modalIsOpen)
    }

    // User Role Change Event
    const changeUserroleSelectHandler = (event) => {
      setSelectedUserroleItem(event);
      setUserroleSelected(event.value);
    };

    // Campus Change Event
    const changeCampusSelectHandler = (event) => {
      setSelectedCampusItem(event);
      setCampusSelected(event);
      //console.log(JSON.stringify({event}));

      if(JSON.stringify({event}).length > 0){

          // Does not require token to authenticate
          fetch(apiEndpoint+"/GetUserLocationList", {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({event})
          })
          .then(res => res.json())
          .then(
              (result) => {
              if (result != undefined) {
                if (result.Locations != undefined) {
                  // var locArr = JSON.parse(result.Locations);
                  // locArr.push({ "value": 0, "label": "All" })
                  // setLocItems(locArr);
                    setLocItems(JSON.parse(result.Locations));
                    // var loclst = JSON.parse(result.Locations);
                    // setSelectedLocItem(loclst[0]);
                    // setLocSelected(loclst[0].value);
                  
                }
              }
            },
              // Note: it's important to handle errors here
              // instead of a catch() block so that we don't swallow
              // exceptions from actual bugs in components.
              (error) => {
                  //console.log(error);
                  // /setError(error);
              }
          )
        }
        else{
          setLocItems(null);
        }

    };

    // Location Change Event
    const changeLocSelectHandler = (event) => {
      setSelectedLocItem(event);
      setLocSelected(event);
    };

    // check first, last name
    const checkName = (name) => {
      const validRegExp = new RegExp(
        '^[A-Za-z]+$'
      );
      if(validRegExp.test(name) && name.length >= 3 && name.length <= 16){
        return true;
      }
      else{
        return false;
      }
    }

    // check email
    const checkEmailID = (email) => {
      const validRegExp = new RegExp(
        '^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$'
      );
      if(validRegExp.test(email)){
        return true;
      }
      else{
        return false;
      }
    }

    // check MobileNumber
    const checkMobileNumber = (MobileNumber) => {
      const validRegExp = new RegExp(
        '^[0-9]{10}$'
      );
      if(validRegExp.test(MobileNumber)){
        return true;
      }
      else{
        return false;
      }
    }

    // check UserName
    const checkUserName = (username) => {
      const validRegExp = new RegExp(
        '^[a-zA-Z0-9_.-]*$'
      );
      if(validRegExp.test(username) && username.length >= 5 && username.length <= 16){
        return true;
      }
      else{
        return false;
      }
    }

    // check Password & Confirm Password
    const checkPasswords = (password,confirmPassword) => {
      const validRegExp = new RegExp(
        '^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$'
      );
      if(validRegExp.test(password) && validRegExp.test(confirmPassword) 
      && password.length >= 7 && password.length <= 15 
      && confirmPassword.length >= 7 && confirmPassword.length <= 15
      && password == confirmPassword){
        return true;
      }
      else{
        return false;
      }
    }

    const saveButton = () => {
      // console.log(JSON.stringify({selectedCampusVal}))
      // console.log(JSON.stringify({selectedLocVal}))
      // console.log(JSON.stringify({SelectedUserroleitem}))
      // console.log(checkName(FirstName))
      // console.log(checkName(LastName))
      // console.log(checkEmailID(EmailID))
      // console.log(checkMobileNumber(MobileNumber))
      // console.log(checkUserName(UserName))
      // console.log(checkPasswords(Password,ConfirmPassword))

      // console.log(typeof(SendMail))
      // console.log(SendSMS)
      // console.log(SendEodMail)

      // const [SendMail, setSendMail] = useState(true);
      // const [SendSMS, setSendSMS] = useState(true);
      // const [SendEodMail, setSendEodMail] = useState(true);

      if( (isUndefined(selectedCampusVal.length) || selectedCampusVal.length == 0) 
      && (isUndefined(selectedLocVal.length) || selectedLocVal.length == 0) ){
        setAlert (
          <ReactBSAlert
            warning
            // title="Campus Selection Is Required!"
            onConfirm={() => setAlert(null)}
            onCancel={() => setAlert(null)}
            confirmBtnBsStyle="info"
          >
            Please select atleast one campus & location from dropdown!
          </ReactBSAlert>
        )
      }
      else{
        if(isUndefined(selectedCampusVal.length) || selectedCampusVal.length == 0){
          setAlert (
            <ReactBSAlert
              warning
              // title="Campus Selection Is Required!"
              onConfirm={() => setAlert(null)}
              onCancel={() => setAlert(null)}
              confirmBtnBsStyle="info"
            >
              Please select atleast one campus from dropdown!
            </ReactBSAlert>
          )
        }
  
        if(isUndefined(selectedLocVal.length) || selectedLocVal.length == 0){
          setAlert (
            <ReactBSAlert
              warning
              // title="Location Selection Is Required!"
              onConfirm={() => setAlert(null)}
              onCancel={() => setAlert(null)}
              confirmBtnBsStyle="info"
            >
              Please select atleast one location from dropdown!
            </ReactBSAlert>
          )
        }
      }

      

      if(selectedCampusVal.length > 0 && selectedLocVal.length > 0 
        && checkName(FirstName) && checkName(LastName) 
        && checkEmailID(EmailID) && checkMobileNumber(MobileNumber) 
        && checkUserName(UserName) && checkPasswords(Password,ConfirmPassword)){

          // UserValidated
            fetch(apiEndpoint+"/SaveUserDetails",
            {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "UserName": UserName,
                "Password": Password,
                "UserFullName": FirstName + " " + LastName,
                "UserEmail": EmailID,
                "UserContactNumber": MobileNumber,
                "SelectedUserroleitem": SelectedUserroleitem,
                "selectedCampusVal": selectedCampusVal,
                "selectedLocVal": selectedLocVal,
                "SendMail":SendMail,
                "SendSMS": SendSMS,
                "SendEoDMail":SendEodMail,
                "Token": sessionStorage.getItem("Clear_AuthUser")
            })
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(result!=undefined)
                    {
                      if(result.status){
                        //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                        setUsersData(result.NewData)
                        setAlert (
                          <ReactBSAlert
                            success
                            // title="Campus Selection Is Required!"
                            //onConfirm={() => setAlert(null)}
                            onConfirm={() =>  toggle()}
                            onCancel={() => setAlert(null)}
                            confirmBtnBsStyle="info"
                          >
                            {result.Message}
                          </ReactBSAlert>
                        )
                      }
                      else{
                        setAlert (
                          <ReactBSAlert
                            warning
                            // title="Campus Selection Is Required!"
                            onConfirm={() => setAlert(null)}
                            onCancel={() => setAlert(null)}
                            confirmBtnBsStyle="info"
                          >
                            {result.Message}
                          </ReactBSAlert>
                        )
                      }
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //setError(error);
                }
            )
      }
    }

    return (
        <>
          <Link className="btn btn-primary waves-effect waves-light" to="#" role="Button"
            onClick={toggle}><i className="mdi mdi-account-plus"></i></Link>
          {modalIsOpen==true}
            <Modal isOpen={modalIsOpen} style={{ maxWidth: "60%" }}>
    
              {/* <ModalHeader toggle={toggle} tag="h5">
                <span>User Details</span>
              </ModalHeader> */}
              <ModalBody toggle={toggle}>
                <AvForm className="needs-validation" onSubmit={saveButton}>
                  {alertmsg}
                  <h4>New User Registration</h4>
                  <Row>

                    <Col md={6}>
                      <label for="FirstName" className="mt-3">First Name *</label>
                      <AvField
                        name="FirstName"
                        placeholder="Enter first name here"
                        type="text"
                        className="form-control"
                        // defaultValue={props.ViolationData.RegistrationNumber}
                        id="FirstName"
                        onChange={(event) => setFirstName(event.target.value)}
                        validate={{
                          required: {value: true, errorMessage: 'Please enter your first name'},
                          pattern: {value: '^[A-Za-z]+$', errorMessage: 'Your first name must be composed only with letters'},
                          minLength: {value: 3, errorMessage: 'Your first name must be between 3 and 16 characters'},
                          maxLength: {value: 16, errorMessage: 'Your first name must be between 3 and 16 characters'}
                        }}
                        required
                      />
                    </Col>

                    <Col md={6}>
                      <label for="LastName" className="mt-3">Last Name *</label>
                      <AvField
                        name="LastName"
                        placeholder="Enter last name here"
                        type="text"
                        className="form-control"
                        // defaultValue={props.ViolationData.RegistrationNumber}
                        id="LastName"
                        onChange={(event) => setLastName(event.target.value)}
                        validate={{
                          required: {value: true, errorMessage: 'Please enter your last name'},
                          pattern: {value: '^[A-Za-z]+$', errorMessage: 'Your last name must be composed only with letters'},
                          minLength: {value: 3, errorMessage: 'Your last name must be between 3 and 16 characters'},
                          maxLength: {value: 16, errorMessage: 'Your last name must be between 3 and 16 characters'}
                        }}
                        required
                      />
                    </Col>

                  </Row>

                  <Row>

                    <Col md={6}>
                      <label for="EmailID" className="mt-3">Email ID *</label>
                      <AvField
                        name="EmailID"
                        placeholder="Enter Email ID here"
                        type="email"
                        className="form-control"
                        // defaultValue={props.ViolationData.RegistrationNumber}
                        id="EmailID"
                        onChange={(event) => setEmailID(event.target.value)}
                        validate={{
                          required: {value: true, errorMessage: 'Please enter your email id'},
                          //pattern: {value: '^[a-zA-Z0-9+_\.-]+@[a-zA-Z0-9.-]+$', errorMessage: 'Invalid email id entered'}
                          email:{value: '^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$', errorMessage: 'Invalid email id entered'}
                        }}
                        required
                      />
                    </Col>

                    <Col md={6}>
                      <label for="MobileNumber" className="mt-3">Mobile Number *</label>
                      <AvField
                        name="MobileNumber"
                        placeholder="Enter mobile number here"
                        type="text"
                        className="form-control"
                        // defaultValue={props.ViolationData.RegistrationNumber}
                        id="MobileNumber"
                        onChange={(event) => setMobileNumber(event.target.value)}
                        validate={{
                          required: {value: true, errorMessage: 'Please enter your mobile number'},
                          pattern: {value: '^[0-9]{10}$', errorMessage: 'Your mobile number must have only 10 digits'}
                        }}
                        required
                      />
                    </Col>

                  </Row>

                  <hr></hr>

                  <h4>Access Details</h4>
                  <Row>

                    <Col md={6}>
                      <label for="UserRole" className="mt-3">Select User Role *</label>
                      <Select value={SelectedUserroleitem} options={Userroleitems} onChange={changeUserroleSelectHandler}></Select>
                    </Col>

                    <Col md={2} >
                        <div
                            className="form-check form-switch form-switch-lg mb-3" style={btnstylesObj}
                        >
                          <input
                              type="checkbox"
                              className="form-check-input"
                              id="chkbxSendMail"
                              
                              onChange={(event) => setSendMail(event.target.checked)}
                          />
                          <label
                              className="form-check-label"
                              htmlFor="chkbxSendMail"
                          >
                              Email
                          </label>
                      </div>
                    </Col>

                    <Col md={2} >
                        <div
                            className="form-check form-switch form-switch-lg mb-3" style={btnstylesObj}
                        >
                          <input
                              type="checkbox"
                              className="form-check-input"
                              id="chkbxSendSMS"
                              
                              onChange={(event) => setSendSMS(event.target.checked)}
                          />
                          <label
                              className="form-check-label"
                              htmlFor="chkbxSendSMS"
                          >
                              SMS
                          </label>
                      </div>
                    </Col>

                    <Col md={2} >
                        <div
                            className="form-check form-switch form-switch-lg mb-3" style={btnstylesObj}
                        >
                          <input
                              type="checkbox"
                              className="form-check-input"
                              id="chkbxSendEoD"
                              
                              onChange={(event) => setSendEodMail(event.target.checked)}
                          />
                          <label
                              className="form-check-label"
                              htmlFor="chkbxSendEoD"
                          >
                              EOD
                          </label>
                      </div>
                    </Col>

                  </Row>

                  <Row>

                    <Col md={6}>
                      <label for="SelectCampus" className="mt-3">Select Campus *</label>
                      {/* <Select value={SelectedCampusitem} options={Campusitems} onChange={changeCampusSelectHandler}></Select> */}

                      <span
                        className="mt-3"
                        data-toggle="popover"
                        data-trigger="focus"
                        data-content="Please selecet Campus(s)"
                      >
                        <ReactSelect
                          options={Campusitems}
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          components={{
                            Option
                          }}
                          onChange={changeCampusSelectHandler}
                          allowSelectAll={false}
                          //value={selectedCampusVal}
                          //controlShouldRenderValue={false}
                          placeholder="Select Campus"
                          required
                        />
                      </span>
                      
                    </Col>

                    <Col md={6}>
                      <label for="SelectLocation" className="mt-3">Select Location *</label>
                      {/* <Select value={SelectedLocitem} options={Locitems} onChange={changeLocSelectHandler}></Select> */}
                    
                      <span
                        className="mt-3"
                        data-toggle="popover"
                        data-trigger="focus"
                        data-content="Please selecet Location(s)"
                      >
                        <ReactSelect
                          options={Locitems}
                          isMulti
                          closeMenuOnSelect={false}
                          hideSelectedOptions={false}
                          components={{
                            Option
                          }}
                          onChange={changeLocSelectHandler}
                          allowSelectAll={false}
                          //value={selectedLocVal}
                          //controlShouldRenderValue={false}
                          placeholder="Select Location"
                        />
                      </span>
                    </Col>

                  </Row>

                  <hr></hr>

                  <h4>Login Details</h4>
                  <Row>

                    <Col md={6}>
                      <label for="UserName" className="mt-3">User Name *</label>
                      <AvField
                        name="UserName"
                        placeholder="Enter user name here"
                        type="text"
                        className="form-control"
                        // defaultValue={props.ViolationData.RegistrationNumber}
                        id="UserName"
                        onChange={(event) => setUserName(event.target.value)}
                        validate={{
                          required: {value: true, errorMessage: 'Please enter user name'},
                          pattern: {value: '^[a-zA-Z0-9_.-]*$', errorMessage: 'User name must be composed only with letters & digits'},
                          minLength: {value: 5, errorMessage: 'User name must be between 5 and 16 characters'},
                          maxLength: {value: 16, errorMessage: 'User name must be between 5 and 16 characters'}
                        }}
                        required
                      />
                    </Col>

                  </Row>

                  <Row>

                    <Col md={6}>
                      <label for="Password" className="mt-3">Password *</label>
                      <AvField
                        name="Password"
                        placeholder="Enter password here"
                        type="password"
                        className="form-control"
                        // defaultValue={props.ViolationData.RegistrationNumber}
                        id="Password"
                        onChange={(event) => setPassword(event.target.value)}
                        validate={{
                          required: {value: true, errorMessage: 'Please enter password'},
                          pattern: {value: '^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$', errorMessage: 'Password must contain 7-15 characters with atleast one digit & a special character'},
                          minLength: {value: 7, errorMessage: 'Password must be between 7 and 15 characters'},
                          maxLength: {value: 15, errorMessage: 'Password must be between 7 and 15 characters'}
                        }}
                        required
                      />
                    </Col>

                    <Col md={6}>
                      <label for="ConfirmPassword" className="mt-3">Confirm Password *</label>
                      <AvField
                        name="ConfirmPassword"
                        placeholder="Enter password here"
                        type="password"
                        className="form-control"
                        // defaultValue={props.ViolationData.RegistrationNumber}
                        id="ConfirmPassword"
                        onChange={(event) => setConfirmPassword(event.target.value)}
                        validate={{
                          required: {value: true, errorMessage: 'Please enter password'},
                          pattern: {value: '^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$', errorMessage: 'Password must contain 7-15 characters with atleast one digit & a special character'},
                          minLength: {value: 7, errorMessage: 'Password must be between 7 and 15 characters'},
                          maxLength: {value: 15, errorMessage: 'Password must be between 7 and 15 characters'},
                          match: {value: 'Password', errorMessage: 'Password does not match'}
                        }}
                        required
                      />
                    </Col>

                  </Row>
                  <hr></hr>
                  
                    <Row>
                      <Col md={9}>
                      </Col>
                      <Col md={1}>
                        <Link className="btn btn-primary waves-effect waves-light" to="#" role="Button"
                        onClick={toggle}>Close</Link>
                      </Col>
                      <Col md={1}>
                      {/* <Link className="btn btn-primary waves-effect waves-light" to="#" role="Button"
              onClick={saveButton}>Submit</Link> */}
                        <button className="btn btn-primary waves-effect waves-light" to="#" role="Button"
                         >Submit</button>
                      </Col>

                    </Row>
                  

                </AvForm>
              </ModalBody>
    
            </Modal>
        </>
      )
    
  };

  export default UserRegistratinoModalComponent;